import { gql, TypedDocumentNode } from '@common/hooks';

export type ApprovalsConfigQueryResponse = {
  approvalConfigs: {
    id: string;
    requireStaffingRequestDocument: boolean;
    staffingRequestDocumentNote?: string;
    requireExtensionOfferDocument: boolean;
    extensionOfferDocumentNote?: string;
  };
};

export const ApprovalsConfigQuery: TypedDocumentNode<ApprovalsConfigQueryResponse> = gql`
  query approvalConfigs {
    approvalConfigs {
      id
      requireExtensionOfferDocument
      requireStaffingRequestDocument
      extensionOfferDocumentNote
      staffingRequestDocumentNote
    }
  }
`;
